import Modal from 'react-modal';
import { Button, Dialog, Loader, Typography } from '@finam/web-ui-kit';
import React, { useEffect } from 'react';
import { IUserInfo } from '../Services/ResponseData';
import { WebService } from '../Services/WebService';
import './ManagerContacts.scss'
import { TokenContext } from '../TokenContext';
import cn from 'classnames'


interface State {
    Manager?: IUserInfo,
    isLoading: boolean,
    isContactOpen: boolean
}

interface IProps {
    label: string,
    managerInfo: { guid: string, telegram: string | undefined },
    collapsed?: boolean
}

export default class ManagerContacts extends React.Component<IProps, State>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            isContactOpen: false
        }
    }

    // handleClickOutside(event: any) {
    //     if (this.modalDiv && this.modalDiv.current && !this.modalDiv.current.contains(event.target)) {
    //         this.setState({ isContactOpen: false });
    //     }
    // };

    componentDidMount() {
        new WebService(this.context.token).GetUserInfo(this.props.managerInfo.guid)
            .then(res =>
                this.setState({ Manager: res.result, isLoading: false }))
    }


    render(): React.ReactNode {
        return <div className='manager-wrapper'>
            {this.state.isLoading ? <Loader width='16' /> : this.renderBody()}
        </div>
    }

    renderBody(): JSX.Element {
        const closeModal =
            () => this.setState({ isContactOpen: false });
        const openModal =
            () => this.setState({ isContactOpen: true });

        return <div className={cn('manager-body', { 'collapsed': this.props.collapsed })} onClick={() => { openModal(); }}>
            <div className='manager-img__wrapepr'>
                <img className='manager-img' src={`data:image/jpeg;base64,${this.state.Manager?.icon64}`} />
            </div>
            <div className='manager-contacts'>
                <div className='manager-title'>{this.props.label}</div>
                <div className='manager-short-title'>{this.props.label}</div>
                <div className='manager-description'>{this.state.Manager?.shortName}</div>
            </div>
            <div>
                <Dialog
                    open={this.state.isContactOpen}
                    onChange={
                        () => {
                            this.setState({ isContactOpen: false });
                        }}>
                    <div className='managerModal-body'>
                        <img className='manager-img' src={`data:image/jpeg;base64,${this.state.Manager?.icon64}`} />
                        <p className='manager-title'>{this.props.label}</p>
                        <p className='manager-description'><b>{this.state.Manager?.fullName}</b></p>
                        <div>
                            <p>Задать вопрос:</p>
                            <div className='manager-connects'>
                                <a href={`mailto:${this.state.Manager?.email}`}><img src={process.env.PUBLIC_URL + 'icons/email_nocirc.svg'} /></a>
                                <a href={this.props.managerInfo?.telegram}><img src={process.env.PUBLIC_URL + 'icons/telegram_nocirc.svg'} /></a>
                            </div>
                        </div>
                        <div>
                            <div><Button size="small"
                                onClick={
                                    (e: any) => { e.stopPropagation();; closeModal(); }}>
                                Закрыть</Button></div>
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    }
}
